import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const detailsCss = css`
  width: 100%;
`;

export const summaryCss = css`
  align-items: center;
  color: ${m('--neutral-v500')};
  cursor: pointer;
  display: flex;
  font-size: 12px;
  gap: ${m('--spacing-xs')};
  line-height: 140%;
  list-style: none;
  padding-block: ${m('--spacing-xs')};
  user-select: none;
  &::-webkit-details-marker {
    display: none;
  }
`;

export const summaryIconCss = css`
  color: ${m('--neutral-v500')};
  details[open] > summary > & {
    transform: rotate(180deg);
  }
`;

export const sourcesListCss = css`
  border-left: 2px solid ${m('--neutral-v500')};
  display: flex;
  flex-direction: column;
  margin-top: ${m('--spacing-xs')};
  padding: 0 0 0 ${m('--spacing-m')};
`;

export const sourceItemCss = css`
  display: flex;
  flex-direction: column;
  font-size: ${m('--p3-mobile-font-size')};
  font-weight: 500;
  gap: ${m('--spacing-xxs')};
  line-height: 120%;
  padding-block: ${m('--spacing-xs')};
`;

export const sourceTitleCss = css`
  color: ${m('--neutral-v700')};
`;

export const sourceLinkCss = css`
  color: ${m('--neutral-v500')};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
